import React from 'react';
import ReactDOM from 'react-dom';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { initializeGtm } from './utils/gtm';

// Same nonce styled-components already reads from window.__webpack_nonce__
// (set in client/public/index.html). style-src currently also allows
// 'unsafe-inline' for the Google Translate widget (index.js, root), which
// makes this nonce redundant for now — kept wired so removing that
// 'unsafe-inline' later (if Google Translate is ever dropped) doesn't
// require touching this file again.
const emotionCache = createCache({
  key: 'mui',
  nonce: window.__webpack_nonce__,
});

const isProductionGTM = true; // Set to true for testing purposes, replace with actual environment variable in production

if (isProductionGTM) {
  initializeGtm('GTM-PCQFRHNF');
}
console.log('isProductionGTM:', isProductionGTM);

document.addEventListener('contextmenu', (e) => {
  e.preventDefault();
});

ReactDOM.render(
  <CacheProvider value={emotionCache}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </CacheProvider>,
  document.getElementById('root')
);

reportWebVitals();
